import React from "react";

export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <header className="border-b border-[#E8E6E1] px-6 md:px-10 py-8 md:py-10 bg-[#FDFCFB]">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5">
        <div>
          {eyebrow && <div className="caption mb-3">{eyebrow}</div>}
          <h1 className="font-serif-display text-3xl md:text-4xl tracking-tight leading-[1.1] text-[#1A1A1A]">
            {title}
          </h1>
          {description && (
            <p className="mt-2 text-sm text-[#6B6A68] max-w-xl">{description}</p>
          )}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-3">{actions}</div>}
      </div>
    </header>
  );
}

export function PageBody({ children, className = "" }) {
  return (
    <div className={`px-6 md:px-10 py-8 md:py-10 ${className}`}>{children}</div>
  );
}
